// extracted by mini-css-extract-plugin
module.exports = {"badge":"MockDataBadge_badge__28zla","dot":"MockDataBadge_dot__U9FYq","mockPulse":"MockDataBadge_mockPulse__u6RCE"};